import config from "utils/config";

module.exports = Promise.all([import("utils/debounce")]).then(deps => {
    let [debounce] = deps;
    debounce = debounce.default;

    (function($, window, document, undefined) {
        "use strict";

        window.TapSearch = window.TapSearch || {};

        var pluginName = "tapSearch",
            defaults = {
                query: {
                    hitsPerPage: 5,
                    attributesToSnippet: "description:25",
                    snippetEllipsisText: "…",
                },
                showNoResults: false,
                resultsHolder: ".suggestions",
                resultElement: "<div></div>",
                debounceMs: 500,
            };

        function Plugin(element, options) {
            this.element = element;
            this.options = $.extend(true, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;

            this.init();

            $(element).focus();

            return this;
        }

        Plugin.prototype = {
            init: function() {
                this.resultCount = 0;
                this.selected = -1;
                this.isOpen = false;

                if (this.options.dropdown) {
                    $(this.element).addClass("search-with-dropdown");
                }

                // this.setupIndex();

                var Immediate = function() {
                    this.is = false;
                };
                this.im = new Immediate();

                this._bindHandlers();
            },
            setOptions: function(options) {
                this.options = $.extend(true, defaults, options);
            },
            showResults: function() {
                $(this.element).addClass("has-results");
                $(this.options.target).show();
                this.isOpen = true;
            },
            hideResults: function(immediately) {
                immediately ? $(this.options.target).hide() : $(this.options.target).fadeOut();
                $(this.element).removeClass("has-results");
                this.isOpen = false;
            },
            changeSelected: function(delta) {
                if (this.selected === -1 && !delta) return;

                var newSelected = this.selected + (delta || 0);

                if (newSelected > this.resultCount - 1) newSelected = this.resultCount - 1;
                if (newSelected < 0) newSelected = 0;
                this.selected = newSelected;

                var $suggestions = $(this.options.target).find(".search-suggestion");
                var self = this;
                var i = 0;
                $suggestions.each(function() {
                    $(this).removeClass("selected");
                    if (i === self.selected) {
                        $(this).addClass("selected");
                        $(this)
                            .find("a")
                            .focus();
                    }
                    i++;
                });
            },
            resultHasChanged: function(hitsA, hitsB) {
                var a = hitsA.reduce(objectIdReducer, []).sort();
                var b = hitsB.reduce(objectIdReducer, []).sort();

                return JSON.stringify(a) !== JSON.stringify(b);
            },
            _bindHandlers: function() {
                var self = this;
                var prevHits;

                var searchFunc = debounce(
                    function(e) {
                        if (e.keyCode == 27) return;

                        self.selected = -1;

                        var query = $(this).val();
                        if (query.length === 0) {
                            prevHits = null;
                            self.hideResults();
                            if (typeof self.options.postRemoveQuery === "function") {
                                self.options.postRemoveQuery();
                            }
                        }

                        if (query.length <= 1) return;

                        function searchDone(result) {
                            if (prevHits && !self.resultHasChanged(prevHits, result)) return;
                            prevHits = result.hits;

                            if (typeof self.options.postSearch === "function") {
                                self.options.postSearch(err, result);
                            }

                            var $suggestions =
                                self.options.resultsHolder !== null
                                    ? $(self.options.target).find(self.options.resultsHolder)
                                    : $(self.options.target);
                            var hits = result.reverse();

                            self.resultCount = hits.length;

                            if (self.resultCount > 0 || self.options.showNoResults) {
                                $suggestions.html("");
                                self.showResults();
                            } else {
                                self.hideResults();
                            }

                            for (var i = self.resultCount - 1; i >= 0; i--) {
                                let hit = hits[i];

                                var $item = $(self.options.resultElement);

                                if (typeof self.options.preAppendItem === "function") {
                                    self.options.preAppendItem($item, hit);
                                }

                                if (self.options.postPickItem) {
                                    $item.on("click", function() {
                                        self.options.postPickItem(hit);
                                        self.hideResults(true);
                                    });
                                }

                                $suggestions.append($item);
                            }

                            if (self.resultCount === 0) {
                                var $item = $(self.options.resultElement);

                                if (typeof self.options.preAppendNoResultsItem === "function") {
                                    self.options.preAppendNoResultsItem($item);
                                }

                                $suggestions.append($item);
                            }

                            self.changeSelected();

                            if (typeof self.options.done === "function") {
                                self.options.done();
                            }
                        }

                        self.im.is = true;

                        var queryObj = {
                            predicates: [{ type: "andOr", value: "and" }],
                            fixedPredicates: [
                                { type: "activeAffiliate", attribute: "active", comparator: "eq", value: "active" },
                            ],
                            pagination: { page: 1 },
                            sort: {},
                            searchString: query,
                        };

                        if (self.options.program) {
                            queryObj.predicates.push({
                                type: "programMember",
                                attribute: "program_member",
                                comparator: "eq",
                                value: self.options.program,
                            });
                        }

                        $.ajax({
                            type: "POST",
                            url: "/api-stateful/ai/query/affiliates/",
                            data: JSON.stringify(queryObj),
                            success: searchDone,
                            headers: {
                                "Content-Type": "application/json",
                                "X-Csrf-Token": config.get("csrf_token"),
                            },
                        });
                    },
                    self.options.debounceMs,
                    this.im,
                );
                $(this.element).on("keyup", searchFunc);

                if (this.options.dropdown) {
                    $(document).on("keydown", function(e) {
                        if (e.keyCode == 27) self.hideResults(true);

                        // Up key
                        if (e.keyCode == 38) {
                            self.changeSelected(-1);
                            var shouldScroll = !self.isOpen;
                            return shouldScroll;
                        }

                        // Down key
                        if (e.keyCode == 40) {
                            self.changeSelected(1);
                            var shouldScroll = !self.isOpen;
                            return shouldScroll;
                        }
                    });

                    $(document).on("click", function(ev) {
                        var $holderTarget = $(self.options.target);
                        var $searchBar = $(self.element);

                        if ($holderTarget[0]) {
                            if (
                                $holderTarget[0] !== ev.target &&
                                $searchBar[0] !== ev.target &&
                                !$.contains($holderTarget[0], ev.target)
                            ) {
                                self.hideResults(true);
                            }
                        }
                    });
                }
            },
        };

        var objectIdReducer = function(carry, item) {
            carry.push(item.id);

            return carry;
        };

        $.fn[pluginName] = function(options) {
            var args = arguments;
            if (options === undefined || typeof options === "object") {
                return this.each(function() {
                    var plugin = $.data(this, "plugin_" + pluginName);
                    if (!plugin) {
                        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
                    } else {
                        plugin.setOptions(options);
                        // plugin.setupIndex();
                    }
                });
            } else if (typeof options === "string" && options[0] !== "_" && options !== "init") {
                if (
                    Array.prototype.slice.call(args, 1).length == 0 &&
                    $.inArray(options, $.fn[pluginName].getters) != -1
                ) {
                    var instance = $.data(this[0], "plugin_" + pluginName);
                    return instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                } else {
                    return this.each(function() {
                        var instance = $.data(this, "plugin_" + pluginName);
                        if (instance instanceof Plugin && typeof instance[options] === "function") {
                            instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                        }
                    });
                }
            }
        };
    })(jQuery, window, document);
});
